import http from "@/http-common";

/* eslint-disable */
class MenuPermissionInquiryDataService {
    [x: string]: any;

    getAreaInfo(): Promise<any> {
        return http.api.post("/getAreaData/");
    }

    // getCountryInfo(): Promise<any>{
    //     return http.api.post("/getCountryData/");
    // }

    getAllMainMenuInfo(data: any): Promise<any> {
        return http.api.post("/getAllMainMenuInfo/", data);
    }

    getDepartmentInfo(): Promise<any> {
        return http.api.post("/getDepartmentInfo/");
    }

    getUserListByMenu(data: any): Promise<any> {
        return http.api.post("/getUserListByMenu/", data);
    }
}

export default new MenuPermissionInquiryDataService();
